import { render, staticRenderFns } from "./SpesaSelf.vue?vue&type=template&id=b291e55c"
import script from "./SpesaSelf.vue?vue&type=script&lang=js"
export * from "./SpesaSelf.vue?vue&type=script&lang=js"
import style0 from "./SpesaSelf.vue?vue&type=style&index=0&id=b291e55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports